import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { sorremApi } from './sorrem-api';

export const store = configureStore({
    reducer: {
        [sorremApi.reducerPath]: sorremApi.reducer,
    },
    devTools: import.meta.env.DEV
        ? {
            name: 'Sorrem Client Store',
            trace: true,
            traceLimit: 25,
        }
        : false,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(sorremApi.middleware),
});

// Tracks page focus and connectivity, so polling can pause on a hidden page (`skipPollingIfUnfocused`).
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
